module.exports = __webpack_public_path__ + "static/media/redo.5eed1c61.svg";